import { Container, useMediaQuery, useTheme } from '@mui/material';
import { useForm, useWatch } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { CreateGuiVersionType } from 'types/compobotGuiVersion.type';
import DesktopLayout from './DesktopLayout';
import MobileLayout from './MobileLayout';
import {
  formDefaultValues,
  handleFormSubmit,
  useGuiVersionForm,
} from './utils';

export default function CreateGuiVersionForm() {
  const { id } = useParams<{ id: string }>();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<CreateGuiVersionType>({
    defaultValues: formDefaultValues,
  });

  // Watch form values for live preview
  const watchedValues = useWatch({ control });

  // Custom hook for state management
  const {
    data,
    colors,
    previewConfig,
    selectedTemplate,
    useCustomPageParams,
    setUseCustomPageParams,
    pretextEnCount,
    pretextHuCount,
    setPretextEnCount,
    setPretextHuCount,
    titleEnCount,
    titleHuCount,
    setTitleEnCount,
    setTitleHuCount,
    subtitleEnCount,
    subtitleHuCount,
    setSubtitleEnCount,
    setSubtitleHuCount,
    populateForm,
    updatePreview,
    onPretextColorChange,
    onTitleColorChange,
    onSubtitleColorChange,
    onOverlayColorChange,
  } = useGuiVersionForm(id);

  // Apply effects
  populateForm(setValue);
  if (watchedValues.guiName !== undefined) {
    updatePreview(watchedValues as CreateGuiVersionType);
  }

  console.log(data);

  const onSubmit = handleSubmit((editedData: CreateGuiVersionType) => {
    handleFormSubmit(editedData, useCustomPageParams, colors, data);
  });

  const commonProps = {
    control,
    errors,
    onSubmit,
    isEditMode: !!data,
    useCustomPageParams,
    setUseCustomPageParams,
    previewConfig,
    selectedTemplate,
    pretextEnCount,
    pretextHuCount,
    setPretextEnCount,
    setPretextHuCount,
    titleEnCount,
    titleHuCount,
    setTitleEnCount,
    setTitleHuCount,
    subtitleEnCount,
    subtitleHuCount,
    setSubtitleEnCount,
    setSubtitleHuCount,
    colors,
    onPretextColorChange,
    onTitleColorChange,
    onSubtitleColorChange,
    onOverlayColorChange,
  };

  return (
    <Container maxWidth="lg" sx={{ px: 0 }} disableGutters>
      {isMobile ? (
        <MobileLayout {...commonProps} />
      ) : (
        <DesktopLayout {...commonProps} />
      )}
    </Container>
  );
}
